export const unloggedInUserRTCCampaignId = 'RTC-rcv-8005'
export const loginUserRTCCampaignID = 'RTC-rcl-8006'
export const registerUserRTCCampaignID = 'RTC-rcv-8007'
